import { TARGET_TASKS_PER_DAY, TARGET_TASKS_PER_WEEK } from './capacity.config';

export function capacityForCount(span, taskCount) {
  const target = span === 'day' ? TARGET_TASKS_PER_DAY : TARGET_TASKS_PER_WEEK;
  const ratio = target <= 0 ? 0 : taskCount / target;
  return { ratio };
}

export function formatHeaderMeta(tasksCount) {
  const noun = tasksCount === 1 ? 'task' : 'tasks';
  return `${tasksCount} ${noun}`;
}
